import React, { useEffect } from "react";
import Slider from "react-slick";
import { Box, Card, Container, Typography } from "@mui/material";
import AOS from "aos";
import "aos/dist/aos.css";
import { useLanguage } from "../../context/LanguageContext";
const OurAward = () => {
  const { language, toggleLanguage, translations } = useLanguage();
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1280, // below 1280px
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1024, // below 1024px
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768, // below 768px
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480, // below 480px
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };




  const awards = [
    {
      id: 1,
      title1: "Capital Markets Authority",
      title2: translations[language]?.sliderCard2,
      img: "/Images/BestEast.png",
      son: "2004"
    },
    {
      id: 2,
      title1: "MISA",
      title2: translations[language]?.sliderCard4,
      img: "/Images/BestEast.png",
      son: "2025"

    },
    {
      id: 3,
      title1: translations[language]?.sliderCard5,
      title2: translations[language]?.sliderCard6,
      img: "/Images/BestEast.png",
      son: "2025"

    },
    {
      id: 4,
      title1: translations[language]?.sliderCard7,
      title2: translations[language]?.sliderCard8,
      img: "/Images/BestEast.png",
      son: "2025"

    },
  ];


  return (
    <Box sx={{ padding: "6rem 0", overflow: "hidden" }}>
      <Box >
        <Box textAlign="start" mb={6}>
          <Typography
            variant="h2"
            // data-aos="fade-up"
            sx={{ textAlign: { xs: "center", md: "start" } }}
          >
            {translations[language]?.sliderTitle}
          </Typography>
          <Typography

            sx={{
              fontSize: "20px",
              color: "rgba(102, 112, 133, 1)",
              fontWeight: "400",
              fontFamily: "SF Pro Display",
              mt: 2,
              maxWidth: "890px",
              textAlign: { xs: "justify", md: "start" },
              px:{xs:3,md:0}
            }}
          >
            {translations[language]?.sliderDescription}
          </Typography>
        </Box>
        <Box
          // data-aos="fade-left"
          sx={{
            mt: 10, // Adds space above the slider
            position: "relative", // Required for absolute positioning inside
            ".slick-dots": {
              position: "absolute",
              bottom: "-50px", // Moves dots 50px below the Box
              width: "100%",
              display: "flex !important",
              justifyContent: "center",
            },
            ".slick-dots li button:before": {
              fontSize: "10px",
              color: "#B0B0B0",
            },
            ".slick-dots li.slick-active button:before": {
              color: "rgba(25, 171, 226, 1)",
            },
          }}
        >

          <Slider {...settings}>
            {awards?.map((award) => (
              <Box
                key={award.id}
                sx={{ pl: 0, pr: 2, position: "relative", height: 280 }}
              >
                {/* Shadow */}
                <Box
                  sx={{
                    position: "absolute",
                    bottom: -1,
                    left: "50%",
                    transform: "translateX(-50%) rotate(3deg)",
                    width: "85%",
                    height: 65,
                    background: "#F3F5F7",
                    borderRadius: "27%",
                    filter: "blur(0px)",
                    zIndex: 0,
                  }}
                />
                {/* Card */}
                <Card
                  elevation={0}
                  sx={{
                    width: "100%",
                    height: 260,
                    borderRadius: "16px",
                    border: "1px solid #e0e0e0",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    padding: 2,
                    backgroundColor: "#fff",
                    zIndex: 1,
                    position: "relative",
                  }}
                >
                  <Box sx={{ position: "relative", mb: 2, width: '150px', height: '120px' }}>
                    <Typography
                      variant="subTitle5"
                      sx={{
                        position: 'absolute',
                        top: '35px', // adjust as needed
                        left: '50%',
                        transform: 'translateX(-50%)',
                        zIndex: 1,
                        color: 'rgba(25, 171, 226, 1)', // ensure visibility
                        fontWeight: '700'
                      }}
                    >
                      {award?.son}
                    </Typography>
                    <img
                      src={award.img}
                      alt="award"
                      style={{ width: '150px', height: '120px', display: 'block', objectFit: 'contain' }}
                    />
                  </Box>

                  <Typography variant="subTitle5">{award.title1}</Typography>
                  <Typography
                    variant="subTitle5"
                    sx={{ marginTop: { xs: "0px", md: "-5px" } }}
                  >
                    {award.title2}
                  </Typography>
                </Card>
              </Box>
            ))}
          </Slider>
        </Box>
      </Box>
    </Box>
  );
};

export default OurAward;
